






























































































































import {
  defineComponent,
  ref,
  Ref,
  onMounted,
  computed,
} from '@vue/composition-api';
import { Seal } from '@oare/types';
import sl from '@/serviceLocator';

export default defineComponent({
  name: 'SealView',
  components: {},
  props: {
    uuid: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const loading = ref(false);
    const isEditing = ref(false);
    const isSaving = ref(false);
    const seal: Ref<Seal> = ref({
      name: '',
      uuid: '',
      imageLinks: [],
      sealImpressions: [],
      sealProperties: [],
      count: 0,
    });
    const sealName = ref(seal.value.name);
    const store = sl.get('store');
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const canUpdateSealSpelling = computed(() =>
      store.hasPermission('EDIT_SEAL')
    );

    const getSideName = (sideNumber: number) => {
      if (sideNumber === 1) {
        return 'obv.';
      }
      if (sideNumber === 2) {
        return 'lo.e.';
      }
      if (sideNumber === 3) {
        return 'rev.';
      }
      if (sideNumber === 4) {
        return 'u.e.';
      }
      if (sideNumber === 5) {
        return 'le.e.';
      }
      if (sideNumber === 6) {
        return 'r.e.';
      }
      return '';
    };

    const closeEdit = () => {
      isEditing.value = false;
      sealName.value = seal.value.name;
    };

    const saveEdit = async () => {
      isSaving.value = true;
      try {
        await server.updateSealName(props.uuid, sealName.value);
        actions.showSnackbar('Successfully updated seal name');
        seal.value.name = sealName.value;
      } catch (err) {
        actions.showErrorSnackbar(
          'Error saving seal name. Please try again.',
          err as Error
        );
        sealName.value = seal.value.name;
      } finally {
        isSaving.value = false;
        isEditing.value = false;
      }
    };

    onMounted(async () => {
      loading.value = true;
      try {
        seal.value = await server.getSealByUuid(props.uuid);
        sealName.value = seal.value.name;
      } catch (err) {
        actions.showErrorSnackbar(
          'Error loading seals. Please try again.',
          err as Error
        );
      } finally {
        loading.value = false;
      }
    });

    return {
      loading,
      seal,
      sealName,
      getSideName,
      closeEdit,
      saveEdit,
      canUpdateSealSpelling,
      isEditing,
      isSaving,
    };
  },
});
